import React from "react";
import ReactDOM from "react-dom/client";
import "./newrelic";
import "./setupApiAuth";
import "./styles/design-system.css";
import App from "./App";
import NewRelicErrorBoundary from "./components/NewRelicErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <NewRelicErrorBoundary>
    <App />
  </NewRelicErrorBoundary>
);
